"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const carabiners_1 = require("@clearsummit/carabiners");
const react_1 = __importDefault(require("react"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Anchor = ({ ariaLabel, label, path, className, disabled, sameTab }) => (!disabled
    ? (react_1.default.createElement("a", { "aria-label": ariaLabel, className: carabiners_1.joinStr(styles_scss_1.default.anchor, className), href: path, target: !sameTab ? '_blank' : '_top', rel: 'noreferrer' }, label))
    : (react_1.default.createElement("span", { "aria-label": ariaLabel, className: carabiners_1.joinStr(styles_scss_1.default.disabled, className) }, label)));
Anchor.defaultProps = {
    className: null,
    disabled: false,
    ariaLabel: undefined,
    sameTab: false
};
exports.default = Anchor;
